import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class RouteDataService {
  adminMenuRouteData = new Subject();
  studentRouteData = new Subject();
  coachMenuRouteData = new Subject();
  parentRouteData = new Subject();
  setMainMenuChildRoute = new Subject();
  setParentMenuRoute = new Subject();
  setAdminMenuRoute = new Subject();
  setCoachMenuRoute = new Subject();
  setStudentMenuRoute = new Subject();
  logout = new Subject();
  login = new Subject();
  unAuthorized = new Subject();
  parentHomeData = new Subject();
  reloadHeatMap = new Subject();
  testScoreUpdate = new Subject();
  userid = new Subject();
}
